<template>
  <div ref="bbeTemplatePreview" @mouseleave="hidePreview" id="previewTemplate">
  <VuePerfectScrollbar class="bbe-templates-preview" :settings="{wheelPropagation: false}">
    <div class="bbe-templates-preview__top"></div>
    <div v-html="content" class="bbe-templates-preview__content"/>
    <div class="bbe-templates-preview__bot"></div>
  </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get} from 'lodash'

export default {
  name: 'TemplatesPreview',
  props: ['content', 'position'],
  components: {
    VuePerfectScrollbar
  },
  methods: {
    hidePreview () {
      this.$emit('close')
    },
    setPosition () {
      const scroll = get(this.$refs, 'bbeTemplatePreview', '')
      if (!scroll) return
      const height = scroll.offsetHeight
      const top = this.position.top + (this.position.height)
      const bottom = window.innerHeight - this.position.bottom + (this.position.height / 2)
      const left = this.position.left + (this.position.width + 5)
      const toTop = window.innerHeight - (bottom + height)
      const toBottom = window.innerHeight - (top + height)
      scroll.style.position = 'fixed'
      scroll.style.zIndex = '5'
      scroll.style.left = left + 'px'
      scroll.style.top = 'auto'
      scroll.style.bottom = 'auto'
      if (toBottom >= 0) {
        scroll.style.top = top + 'px'
      } else if (toTop >= 0) {
        scroll.style.bottom = bottom + 'px'
      } else {
        scroll.style.top = 0
      }
    }
  },
  mounted () {
    this.setPosition()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-templates-preview {
    background-color: $color-white;
    box-sizing: border-box;
    box-shadow: 0 0 25px rgba($color-accent, 0.12);
    border-radius: 10px;
    max-width: 616px;
    max-height: 524px;
    z-index: 99;

    &__top, &__bot {
      position: sticky;
      width: 100%;
      height: 25px;
      background-color: $color-white;
    }

    &__top {
      top: 0;
    }

    &__bot {
      bottom: 0;
    }

    &__content {
      margin: 0 25px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesPreview/TemplatesPreview.vue